import type { BoxInfo } from '@lub0v/santa-utils';

export function getDrawStatusKey(info: Pick<BoxInfo, 'box' | 'isActiveDraw'>) {
  if (info.box.isArchived) return 'box.organizer.archive.badge';
  return info.isActiveDraw ? 'game.main.drawDone' : 'game.main.drawPending';
}
